import React, { Suspense } from "react";

import { Navigate, Route, Routes } from "react-router-dom";

import SearchUser from "../components/SearchUser";
import SideMenu from "../components/SideMenu";
import Skeleton from "../components/Skeleton";
import { useVersion } from "../Context/hasBetaActiveContext";
import ListBalanceReserve from "../pages/BalanceReserve";
import LaunchAdjustment from "../pages/LaunchAdjustment";
import ListDefault from "../pages/ListDefault";
import ListPaymentsCreliq from "../pages/ListPaymentsCreliq";
import ListSells from "../pages/ListSells";
import ListBlockAccount from "../pages/ListsInLote/blockAccount";
import ListBlockCard from "../pages/ListsInLote/blockCard";
import ListAlterLimits from "../pages/ListsInLote/changeLimit";
import LockAccountList from "../pages/LockAccountList";
import NewGroups from "../pages/NewGroups";
import NewListPayments from "../pages/NewListPayments";
import NewRecovery from "../pages/NewRecovery";
import NewUsers from "../pages/NewUsers";
import NotFound from "../pages/NotFound";
import PageAtendimento from "../pages/PageAtendimento";
import { PermissionRouter, PrivateRouter } from "./Route";
import RedirectSSO from "../pages/RedirectSSO";
import Loading from "../components/Loading";
import ServiceProtocols from "../pages/ServiceProtocols";
import OperationPeaksDashboard from "../pages/OperationPeaksDashboard";
import { useClient } from "../hooks/ClientProvider";
import { storageService } from "../services/storageService";
import PermissionsManagement from "../pages/PermissionsManagement";

const NewLogin = React.lazy(() => import("../pages/NewLogin"));
const Home = React.lazy(() => import("../pages/home"));
const ControlUser = React.lazy(() => import("../pages/controlUser"));
const ControlDomainSSO = React.lazy(() => import("../pages/controlDomainSSO"));
const Classification = React.lazy(() => import("../pages/classification"));
const Reports = React.lazy(() => import("../pages/reports"));
const Printers = React.lazy(() => import("../pages/printers"));
const ManageAcess = React.lazy(() => import("../pages/manageAcess"));
const ProductList = React.lazy(() => import("../pages/productList"));
const StoreList = React.lazy(() => import("../pages/storeList"));
const PostSale = React.lazy(() => import("../pages/PostSale"));
const PostPayment = React.lazy(() => import("../pages/PostPayment"));
const CanceledListInsurance = React.lazy(() =>
  import("../pages/CanceledListInsurance")
);
const IssuerCycleList = React.lazy(() => import("../pages/IssuerCycles"));
const LockTypesList = React.lazy(() => import("../pages/LockTypesList"));
const TypesAdjustments = React.lazy(() => import("../pages/TypesAdjustments"));
const ScheduleShopkeeper = React.lazy(() =>
  import("../pages/ScheduleShopkeeper")
);
const Occurrences = React.lazy(() => import("../pages/occurrences"));

const Pdf = React.lazy(() => import("../pages/pdf"));
const ControlClassification = React.lazy(() =>
  import("../pages/classification/Modals/modalControlSubClass")
);
const ControlGroup = React.lazy(() =>
  import("../pages/classification/Modals/modalControlClass")
);
const Solicitation = React.lazy(() => import("../pages/solicitation"));
const SolicitationType = React.lazy(() => import("../pages/solicitationType"));

const AccessDenied = React.lazy(() => import("../pages/AccessDenied"));
const SSOManagement = React.lazy(() => import("../pages/ssoManagement"));
const PushManagement = React.lazy(() => import("../pages/PushManagement"));

function RoutesPage() {
  const { hasBetaActive } = useVersion();
  const { client } = useClient();
  const token = storageService.getToken();

  return (
    <Suspense
      fallback={
        <div
          style={{
            height: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Loading />
        </div>
      }
    >
      <Routes>
        <Route
          path="/"
          exact
          element={
            token ? (
              client ? (
                <Navigate to="/atendimento" replace />
              ) : (
                <Navigate to="/home" replace />
              )
            ) : (
              <NewLogin />
            )
          }
        />
        {/* <Route
            path="/recuperacao-senha"
            exact
            element={<PasswordRecovery />}
          /> */}
        <Route path="/recuperacao-senha" exact element={<NewRecovery />} />
        <Route path="/sso_login" exact element={<RedirectSSO />} />s
        <Route
          path="/groups"
          exact={false}
          element={
            <PermissionRouter permission="crud_group_user">
              <SideMenu>
                <NewGroups />
              </SideMenu>
            </PermissionRouter>
          }
        />
        <Route
          path="/lista-de-produtos"
          exact={false}
          element={
            <PermissionRouter permission="view_list_product_issuer">
              <SideMenu menuSelected={["1"]}>
                <ProductList />
              </SideMenu>
            </PermissionRouter>
          }
        />
        <Route
          path="/lista-dos-tipos-de-ajustes"
          exact={false}
          element={
            <PermissionRouter permission="view_types_adjustments">
              <SideMenu menuSelected={["2"]}>
                <TypesAdjustments />
              </SideMenu>
            </PermissionRouter>
          }
        />
        <Route
          path="/agenda-lojista"
          exact={false}
          element={
            <PermissionRouter permission="permission_schedules_store">
              <Skeleton menuSelected={["5"]}>
                <ScheduleShopkeeper />
              </Skeleton>
            </PermissionRouter>
          }
        />
        <Route
          path="/listagem-pagamentos"
          exact
          element={
            <PermissionRouter permission="list_pay_launch">
              <SideMenu>
                <NewListPayments />
              </SideMenu>
            </PermissionRouter>
          }
        />
        <Route
          path="/listagem-pagamentos-creliq"
          exact
          element={
            <PermissionRouter permission="list_pay_launch">
              <SideMenu>
                <NewListPayments />
              </SideMenu>
            </PermissionRouter>
          }
        />
        <Route
          path="/gestao-protocolos"
          exact={false}
          element={
            <PermissionRouter permission="permission_view_service_protocols">
              <SideMenu>
                <ServiceProtocols />
              </SideMenu>
            </PermissionRouter>
          }
        />
        <Route
          path="/dashboard-picos-operacao"
          exact={false}
          element={
            <PermissionRouter permission="permission_view_operation_peaks">
              <SideMenu>
                <OperationPeaksDashboard />
              </SideMenu>
            </PermissionRouter>
          }
        />
        <Route
          path="/listagem-vendas"
          exact={false}
          element={
            <PermissionRouter permission="list_sale_launch">
              <SideMenu>
                <ListSells />
              </SideMenu>
            </PermissionRouter>
          }
        />
        <Route
          path="/lancar-vendas"
          exact={false}
          element={
            <PermissionRouter permission="make_sales_manual">
              <SideMenu>
                <PostSale />
              </SideMenu>
            </PermissionRouter>
          }
        />
        <Route
          path="/lancar-pagamentos"
          exact={false}
          element={
            <PermissionRouter permission="permission_register_payment">
              <SideMenu>
                <PostPayment />
              </SideMenu>
            </PermissionRouter>
          }
        />
        <Route
          path="/listagem-reserva-de-saldo"
          exact={false}
          element={
            <PermissionRouter permission="get_reserve_balance">
              <SideMenu>
                <ListBalanceReserve />
              </SideMenu>
            </PermissionRouter>
          }
        />
        <Route
          path="/lista-de-ciclos"
          exact={false}
          element={
            <PermissionRouter permission="view_cycles_issuer">
              <SideMenu menuSelected={["3"]}>
                <IssuerCycleList />
              </SideMenu>
            </PermissionRouter>
          }
        />
        <Route
          path="/lista-dos-tipos-de-bloqueio-cartao"
          exact={false}
          element={
            <PermissionRouter permission="backoffice_view_list_lock_card">
              <SideMenu menuSelected={["4"]}>
                <LockTypesList />
              </SideMenu>
            </PermissionRouter>
          }
        />
        <Route
          path="/lista-dos-tipos-de-bloqueio-conta"
          exact={false}
          element={
            <PermissionRouter permission="backoffice_view_list_lock_account">
              <SideMenu menuSelected={["5"]}>
                <LockAccountList />
              </SideMenu>
            </PermissionRouter>
          }
        />
        <Route
          path="/lista-de-lojas"
          exact={false}
          element={
            <PermissionRouter permission="backoffice_view_list_stores">
              <SideMenu menuSelected="6">
                <StoreList />
              </SideMenu>
            </PermissionRouter>
          }
        />
        <Route
          path="/lista-de-seguros-cancelados"
          exact={false}
          element={
            <PrivateRouter>
              <SideMenu menuSelected={["7"]}>
                <CanceledListInsurance />
              </SideMenu>
            </PrivateRouter>
          }
        />
        <Route
          path="/bloqueio-cartao-em-lote"
          exact={false}
          element={
            <PrivateRouter permission="view_bloqcard_in_batch">
              <Skeleton menuSelected={["11"]}>
                <ListBlockCard />
              </Skeleton>
            </PrivateRouter>
          }
        />
        <Route
          path="/bloqueio-contas-em-lote"
          exact={false}
          element={
            <PrivateRouter permission="view_bloqaccount_in_batch">
              <Skeleton menuSelected={["12"]}>
                <ListBlockAccount />
              </Skeleton>
            </PrivateRouter>
          }
        />
        <Route
          path="/alteracao-limite-em-lote"
          exact={false}
          element={
            <PrivateRouter permission="view_alter_limit_batch">
              <Skeleton menuSelected={["13"]}>
                <ListAlterLimits />
              </Skeleton>
            </PrivateRouter>
          }
        />
        <Route
          path="/ocorrencias"
          exact={false}
          element={
            <PrivateRouter>
              <Skeleton menuSelected={[""]}>
                <Occurrences />
              </Skeleton>
            </PrivateRouter>
          }
        />
        <Route
          path="/classificacao"
          exact
          element={
            <PermissionRouter permission="crud_classification">
              <SideMenu>
                <Classification />
              </SideMenu>
            </PermissionRouter>
          }
        />
        <Route
          path="/solicitacoes"
          exact
          element={
            <PermissionRouter permission="view_solicitation">
              <SideMenu>
                <Solicitation />
              </SideMenu>
            </PermissionRouter>
          }
        />
        <Route
          path="/reports"
          exact
          element={
            <PermissionRouter permission="request_report">
              <Skeleton menuSelected={["6"]}>
                <Reports />
              </Skeleton>
            </PermissionRouter>
          }
        />
        <Route
          path="/tipos_solicitacoes"
          exact
          element={
            <PermissionRouter permission="crud_solicitation_type">
              <SideMenu menuSelected={["6"]}>
                <SolicitationType />
              </SideMenu>
            </PermissionRouter>
          }
        />
        <Route
          path="/atendimento"
          exact={false}
          element={
            <PrivateRouter>
              {client ? (
                hasBetaActive === true ? (
                  <SideMenu>
                    <PageAtendimento />
                  </SideMenu>
                ) : (
                  <SideMenu>
                    <Home />
                  </SideMenu>
                )
              ) : (
                <Navigate to="/home" replace />
              )}
            </PrivateRouter>
          }
        />
        <Route
          path="/home"
          exact={false}
          element={
            <PrivateRouter>
              {!client ? (
                <SideMenu isHome>
                  <SearchUser />
                </SideMenu>
              ) : (
                <Navigate to="/atendimento" replace />
              )}
            </PrivateRouter>
          }
        />
        <Route
          path="/controleUsuario"
          exact
          element={
            <PrivateRouter>
              <SideMenu>
                <ControlUser />
              </SideMenu>
            </PrivateRouter>
          }
        />
        <Route
          path="/controleDominioSSO"
          exact
          element={
            <PermissionRouter permission="view_sso_domain">
              <SideMenu>
                <ControlDomainSSO />
              </SideMenu>
            </PermissionRouter>
          }
        />
        <Route
          path="/usuario"
          exact
          element={
            <PermissionRouter permission="crud_user">
              <SideMenu>
                <NewUsers />
              </SideMenu>
            </PermissionRouter>
          }
        />
        <Route
          path="/gestao-sso"
          exact
          element={
            <PermissionRouter permission="view_sso_domain">
              <SideMenu>
                <SSOManagement />
              </SideMenu>
            </PermissionRouter>
          }
        />
        <Route
          path="/permissions-management"
          exact
          element={
            <PermissionRouter
              permission="permission_manage_processor_functionalities"
              onlyForRpeUsers
              onlyForRpeRoleUsers
            >
              <SideMenu>
                <PermissionsManagement />
              </SideMenu>
            </PermissionRouter>
          }
        />
        <Route
          path="/gestao-atendimento"
          exact
          element={
            <PermissionRouter 
              permission="permission_manage_push_sac"
              onlyForRpeUsers
              onlyForRpeRoleUsers
            >
              <SideMenu>
                <PushManagement />
              </SideMenu>
            </PermissionRouter>
          }
        />
        <Route
          path="/printers"
          exact
          element={
            <PermissionRouter permission="manage_printer">
              <SideMenu>
                <Printers />
              </SideMenu>
            </PermissionRouter>
          }
        />
        <Route
          path="/access"
          exact
          element={
            <PermissionRouter permission="ip_restriction">
              <SideMenu>
                <ManageAcess />
              </SideMenu>
            </PermissionRouter>
          }
        />
        <Route
          path="/classificacao/nova"
          exact
          element={
            <PermissionRouter permission="crud_classification">
              <Skeleton menuSelected={["2"]}>
                <ControlClassification />
              </Skeleton>
            </PermissionRouter>
          }
        />
        <Route
          path="/grupo/novo"
          exact
          element={
            <PermissionRouter permission="crud_classification">
              <Skeleton menuSelected={["2"]}>
                <ControlGroup />
              </Skeleton>
            </PermissionRouter>
          }
        />
        <Route
          path="/lista-de-inadimplencia"
          exact={false}
          element={
            <PermissionRouter permission="permission_view_inadimplencia">
              <Skeleton menuSelected={["8"]}>
                {" "}
                {/*  a que se refere essa prorpiedade menu select?  */}
                <ListDefault />
              </Skeleton>
            </PermissionRouter>
          }
        />
        <Route
          path="/lancar-ajuste"
          exact={false}
          element={
            <PermissionRouter permission="view_launch_adjustment">
              <SideMenu>
                <LaunchAdjustment />
              </SideMenu>
            </PermissionRouter>
          }
        />
        <Route
          path="/access-denied"
          exact={false}
          element={
            <PrivateRouter>
              <SideMenu>
                <AccessDenied />
              </SideMenu>
            </PrivateRouter>
          }
        />
        <Route path="/pdf" element={<Pdf />} />
        <Route element={<NotFound />} />
      </Routes>
    </Suspense>
  );
}
export default RoutesPage;
